"use strict";

exports.__esModule = true;
exports.getDependsOnOwnProps = getDependsOnOwnProps;
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..
function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
}


//////////////////
// WEBPACK FOOTER
// /~/redux-form/lib/helpers.js
// module id = wwio
// module chunks = 0